import {
	HttpResponse,
	HttpErrorResponse,
	HttpEvent,
	HttpHandlerFn,
	HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators'
/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
	const authService = inject(AuthService);

	// Clone the request object
	let newReq = req.clone();

	return next(newReq).pipe(
		tap(event => {
			if (event instanceof HttpResponse) {
				// Se puede hacer algo con la respuesta exitosa aquí, por el momento no hay logico adicional
			}
		}),
		catchError((httpError: HttpErrorResponse) => {
			// Retornamos un error controlado sin que Angular lo detecte como una falla crítica
			const status = httpError?.status;
			const backendError = httpError?.error?.error;
			const errorCodes = [241, 242, 243, 244];
			// Manejar errores específicos de token no autorizado (401 con errno 241, 242, 243 o 244)
			if (status === 401 && errorCodes.includes(backendError?.errno)) {
				// Sign out
				authService.forceSignOut();
				// Reload the app
				location.reload();
			}
			return throwError(() => backendError);
		})
	);
}